export const pascalCase = (w) => w && w.replace(/(^\w|\s\w)/g, m => m.toUpperCase());

export const templateReachoutEmail = (
  email,
  subject,
  html,
  candidateName,
  recruiterName,
  recruiterTitle,
  companyName,
) => {
  html = html.replaceAll("[[candidate_name]]", candidateName);
  html = html.replaceAll("[[recruiter_name]]", recruiterName);
  html = html.replaceAll("[[recruiter_title]]", recruiterTitle);
  html = html.replaceAll("[[company_name]]", companyName);

  return `mailto:${email}?subject=${subject}&body=${encodeURIComponent(html)}`;
};


export const personalisedReachoutEmail = (
  email,
  name,
  recruiterName,
  recruiterTitle,
  companyName,
) => (
`mailto:${email}?subject=${`Join ${"Vita"}'s early team in Singapore`}&body=${encodeURIComponent(
`Hey ${name},

I am ${recruiterName} from ${companyName}, an all-in-one platform for Chief People Officers.

We just raised $18MM Series A with Accel, brought in 100+ founder and execs from companies like Google and Pinterest as investors and we are currently working with cool customers like Figma, Calm and Discord. 

We are looking to scale an early team in Singapore, and this is a once-in-a-lifetime opportunity to come on board. I was reviewing profiles with my CEO/Founder Joseph, and we both think you would be a great fit on our team.

What might get you excited:
- We are on high growth path and you'll be the only one to see how Singapore team get brought from 0 to 1.
- Highly competitive compensation ~150k SGD salary with equity on top of it.
- We've built the world's #1 social network for CPO which includes CPO of Lyft, Dropbox, Bumble and 1,000 more.

Cheers and looking forward.


${recruiterName} | ${recruiterTitle} @ ${companyName}`,
)
}`
); 